<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/bwt/solution1-banner.jpg`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-left">金融</h2>
							<h4 class="text-left color-white">筑实金融安全底座，加速数智创新</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">金融行业</h2>
				<div style="margin-top: 48px; font-size: 18px">
					持续为金融行业提供信创产品及AI、云计算和数据专业服务支持，在算力底座、数字化架构、数据安全、数据模型、风控、营销等场景持续创新，助力银行数字化转型，并推动开展供应链金融、数据资产入表融资等深层次的合作。
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">解决方案</h2>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/bwt/s1-1.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="t1">为金融行业提供澎湃算力</div>
						<div class="t2">以搭载鲲鹏处理器的服务器产品为算力核心，基于广泛的软硬件生态构建起强大算力基础设施架构，为金融行业各类业务应用提供安全、可靠、高效的运行环境。</div>
					</div>
				</div>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="t1">数据安全管控平台</div>
						<div class="t2">围绕数据安全生命周期和具体应用场景，搭建数据安全管控平台的技术架构，实现对数据违规使用、非法访问、异常操作等风险的事前防范与事后溯源，有效保护金融行业核心系统数据安全。</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/bwt/s1-2.jpg" style="border-radius: 12px;">
					</div>
				</div>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/bwt/s1-3.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="t1">可靠、安全的服务架构</div>
						<div class="t2">依托其广泛的技术产品生态和丰富的国产化产品矩阵，搭建可靠、安全的架构；整合多云多活、应用攻防、全网可观测性架构和安保攻防等技术服务，实现对应用的全方位保护，应对AI时代新的安全挑战。</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'

export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/bwt/sbg.jpg");
}
.solution {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%
	}
	.txt {
		flex: 1;
		margin: 40px 36px;
		.t1 {
			font-size: 24px;
			font-weight: 600;
			color: #000;
		}
		.t2 {
			margin-top: 12px;
			color: #000;
		}
	}

}
</style>
